<template>
  <div class="d-flex align-items-center justify-content-between flex-wrap">
    <div class="d-flex align-items-center mb-1 mb-md-0">
      <b-button
        v-if="showSave"
        variant="primary"
        class="mr-1"
        @click="handleSaveFilters"
      >
        Save Filter
      </b-button>
      <saved-filters-dropdown
        v-if="showSavedFilters"
        :screen="screen"
        @save-current="handleSaveFilters"
        @apply-filter="$emit('apply-saved-filter', $event)"
        @edit-filter="$emit('edit-saved-filter', $event)"
      />
    </div>
    <div class="d-flex align-items-center mb-1 mb-md-0">
      <b-button
        variant="primary"
        class="mr-1"
        :disabled="isButtonDisabled"
        @click="handleApplyClick"
      >
        {{ buttonText }}
      </b-button>
      <b-button
        variant="outline-secondary"
        @click="handleClearFilters"
      >
        Clear
      </b-button>
    </div>
  </div>
</template>

<script>
import { BButton } from 'bootstrap-vue'
import SavedFiltersDropdown from './SavedFiltersDropdown.vue'

export default {
  components: {
    BButton, // Include BButton in the components section
    SavedFiltersDropdown,
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    filterData: Object,
    // eslint-disable-next-line vue/require-default-prop
    applyFilters: Function,
    // eslint-disable-next-line vue/require-default-prop
    clearFilters: Function,
    showSave: {
      type: Boolean,
      default: false,
    },
    showSavedFilters: {
      type: Boolean,
      default: false,
    },
    screen: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      filterChanged: false, // Track whether a filter has been changed
      applied: false, // Track whether filters are applied
    }
  },
  computed: {
    isButtonDisabled() {
      return (!this.filterChanged || this.applied)
    },
    buttonText() {
      return this.applied ? 'Applied' : 'Apply'
    },
  },
  watch: {
    filterData: {
      handler(newData) {
        if (Object.keys(newData).length !== 0) {
          this.filterChanged = true
        } else {
          this.filterChanged = false
        }
        this.applied = false
      },
      deep: true,
    },
  },
  methods: {
    handleSaveFilters() {
      this.$emit('save-filters')
    },
    handleApplyClick() {
      if (this.filterChanged) {
        this.applied = true // Mark filters as applied
        this.applyFilters()
        this.filterChanged = false
      }
    },
    handleClearFilters() {
      this.applied = false // Mark filters as not applied
      this.filterChanged = false // Reset the filter changed flag
      this.clearFilters()
    },
    forceAppliedState() {
      this.applied = true
      this.filterChanged = false
    },
  },
}
</script>
